import { createStack } from '@famly/mf_layout_stack';
/** Simple wrapper for the modal's top elements */
export const ModalHeader = createStack({
    component: 'header',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'anchor-center',
});
